import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import React from "react";

export function Loader() {
  return (
    <Box sx={{ textAlign: "center" }}>
      <CircularProgress color="primary" />
      <Typography>Loading...</Typography>
    </Box>
  );
}

export function SmallLoader() {
  return (
    <Box sx={{ textAlign: "center" }}>
      <CircularProgress color="primary" size={24} />
      <Typography variant="subtitle2">Loading...</Typography>
    </Box>
  );
}
